
import { defineComponent, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  IssueStrategyService
} from '@/views/dashboard/group/client/terminal-info/issue-strategy/issue-strategy.service'
import MessagePush from '@/views/dashboard/notice-manage/message-push/message-push.vue'

export default defineComponent({
  components: { MessagePush },
  props: {
    deviceId: {
      type: String,
      default: ''
    }
  },

  setup (props, context) {
    const injector = useReflectiveInjector([IssueStrategyService])
    const service = injector.get(IssueStrategyService)

    const isLoading = ref(false)

    return {
      isLoading,
    }
  }
})
